import React from 'react';
import SecondaryNav from './SecondaryNav';
import fb_logo from './social/facebook.svg';
import instagram_logo from './social/instagram.svg';
import yt_logo from './social/youtube.svg';
import x_logo from './social/X_logo_2023.svg';
import { getCMSObject, TeleScript } from 'sg-ui-components';

const Footer = () => {
    return (
        <footer>
            <div className='d-flex flex-column align-items-center justify-content-center'>
                <div className='social-links'>
                    <a className='fb' href='https://www.facebook.com/illinoislottery/' target='_blank' rel='noopener noreferrer'>
                        <img src={fb_logo} alt='Illinois Lottery on Facebook' />
                    </a>
                    <a className='gr' href='https://www.instagram.com/illinoislottery/' target='_blank' rel='noopener noreferrer'>
                        <img src={instagram_logo} alt='Illinois Lottery on Instagram' />
                    </a>
                    <a className='tw' href='https://twitter.com/illinoislottery/' target='_blank' rel='noopener noreferrer'>
                        <img src={x_logo} alt='Illinois Lottery on Twitter' />
                    </a>
                    <a className='yt' href='https://www.youtube.com/user/TheIllinoisLottery' target='_blank' rel='noopener noreferrer'>
                        <img src={yt_logo} alt='Illinois Lottery on Youtube' />
                    </a>
                </div>
                <SecondaryNav />
                <div className='disclaimer-text'>
                    <TeleScript line={getCMSObject('data.microsite.general.footerDisclaimer.contentHTML')} />
                </div>
                <div className='copyright-text'>
                    <TeleScript line={getCMSObject('data.microsite.general.footerCopyright.contentHTML')} />
                </div>
            </div>
        </footer>
    );
};

export default Footer;
